import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


interface User {
  name: string;
  image?: string;
  uid:number;
  rid:number;
  isAuthenticated?:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<User | null>(null);
  currentUser$ = this.userSubject.asObservable();
  private userKey = 'userDetails';
  private orgKey='orgId';
  private answerMode='answerMode';
  private trainerMode='trainerMode';
  constructor() {}

  // Method to set user data
  setUser(name: string, uid:number,rid:number,isAuthenticated:boolean,image?: string,) {
    const user: User = { name, image,uid,rid,isAuthenticated };
    this.userSubject.next(user);
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }
  setOrgId(orgId:number){
    
    localStorage.setItem(this.orgKey,JSON.stringify(orgId));
  }
  getOrgId():number{
    
    const orgId = localStorage.getItem(this.orgKey);
    
    return orgId ? JSON.parse(orgId) : 0;
  }
  clearOrgid(){
    localStorage.removeItem(this.orgKey);
  }
  // Method to get current user data
  getUser() {
    const userDetails = localStorage.getItem(this.userKey);
    return userDetails ? JSON.parse(userDetails) : null;
  }

  // Method to clear user data
  clearUser() {
    this.userSubject.next(null);
    localStorage.removeItem(this.userKey);

  }
  userAuthenticated(){
    const userDetails = this.getUserDetails();
    return userDetails ? userDetails.isAuthenticated : false;
  }
  getUserId(){
    const userDetails = this.getUserDetails();
    return userDetails ? userDetails.uid : null;
  }
  getRoleId(){
    const userDetails = this.getUserDetails();
    return userDetails ? userDetails.rid : null;
  }
  getUserLogoInitials() {
    const userDetails = this.getUserDetails();
    if (userDetails && userDetails.name) {
      const username = userDetails.name;
      return username.length <= 2 ? username.toUpperCase() : username.slice(0, 2).toUpperCase();
    }
    return null; // Return null if userDetails or name is not available
  }
  getUserDetails() {
    const userDetails = localStorage.getItem(this.userKey);
    return userDetails ? JSON.parse(userDetails) : null;
  }
  setAnswerMode(answerMode:string){
    localStorage.setItem(this.answerMode,JSON.stringify(answerMode));  
  }
  getAnswerMode():string{
    
    const answerMode = localStorage.getItem(this.answerMode);
    
    return answerMode ? JSON.parse(answerMode) : 'Table';
  }
  clearAnswerMode(){
    localStorage.removeItem(this.answerMode);
  }
  setTrainerMode(trainerMode:boolean){
    localStorage.setItem(this.trainerMode,JSON.stringify(trainerMode));  
  }
  getTrainerMode():boolean{
    
    const trainerMode = localStorage.getItem(this.trainerMode);
    
    return trainerMode ? JSON.parse(trainerMode) : false;
  }
  clearTrainerMode(){
    localStorage.removeItem(this.trainerMode);
  }
}